export default {
  text: {
    en: '{itemsCount, plural, one {# product} other {# products}} added to the Queue',
  },
}
